
{
  "familyId": "GET-MACHT-GRONDTAL",
  "questions": [
    {
      "id": "GET-MACHT-GRONDTAL-001",
      "familyId": "GET-MACHT-GRONDTAL",
      "module": "Getalbegrip",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_grondtal",
      "questionType": "multiple_choice",
      "question": "Een bioloog telt bacteriën. Elke bacterie deelt zich 5 keer in tweeën. Hoeveel bacteriën zijn er na 5 delingen? (Bereken $2^5$)",
      "options": ["32", "10", "25", "64"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Machtsverheffen",
            "content": "Bij machtsverheffen vermenigvuldig je het grondtal met zichzelf, zo vaak als de exponent aangeeft. $2^5$ = 2 × 2 × 2 × 2 × 2.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "macht_grondtal_2",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.macht-als-vermenigvuldigen", "label": "Doet grondtal × exponent", "optionIndex": 1 },
          { "id": "get.exponent-als-grondtal", "label": "Verwisselt grondtal en exponent", "optionIndex": 2 },
          { "id": "get.exponent-met-1-erbij", "label": "Telt extra factor 2 erbij", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Vermenigvuldig het grondtal met zichzelf, zo vaak als de exponent aangeeft. $2^5$ = 2 × 2 × 2 × 2 × 2. Reken stap voor stap: 2 × 2 = 4, × 2 = 8, × 2 = 16, × 2 = 32. Na 5 delingen zijn er 32 bacteriën. Let op: $2^5$ ≠ 2 × 5, want bij een macht vermenigvuldig je 2 met zichzelf, niet met 5.",
        "solutionSteps": [
          "$2^5$ = 2 × 2 × 2 × 2 × 2",
          "2 × 2 = 4",
          "4 × 2 = 8",
          "8 × 2 = 16",
          "16 × 2 = 32"
        ],
        "distractorExplanations": {
          "0": "Goed! $2^5$ = 2 × 2 × 2 × 2 × 2 = 32. Vijf keer 2 met elkaar vermenigvuldigd.",
          "1": "Je dacht waarschijnlijk dat je grondtal × exponent rekent. Maar 2 × 5 = 10 is vermenigvuldigen, niet machtsverheffen. Onthoud: $2^5$ = 2 × 2 × 2 × 2 × 2 = 32.",
          "2": "Je dacht waarschijnlijk dat grondtal en exponent omgedraaid zijn. Maar $5^2$ = 25, terwijl $2^5$ = 32. Onthoud: het kleine getal rechtsboven is de exponent.",
          "3": "Je dacht waarschijnlijk dat het $2^6$ is. Maar $2^6$ = 64, terwijl $2^5$ = 32 (één factor minder). Onthoud: tel het aantal keren dat je vermenigvuldigt — hier 5 keer."
        }
      }
    },
    {
      "id": "GET-MACHT-GRONDTAL-002",
      "familyId": "GET-MACHT-GRONDTAL",
      "module": "Getalbegrip",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_grondtal",
      "questionType": "multiple_choice",
      "question": "Een informaticus werkt met kilobytes. 1 kilobyte = $10^3$ bytes. Hoeveel bytes is dat?",
      "options": ["1.000", "30", "100", "10.000"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Machten van 10",
            "content": "Bij grondtal 10 is de exponent gelijk aan het aantal nullen. $10^1$ = 10, $10^2$ = 100, $10^3$ = 1.000, $10^4$ = 10.000.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "macht_grondtal_10",
      "variantIndex": 2,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.79,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.macht-als-vermenigvuldigen", "label": "Doet grondtal × exponent", "optionIndex": 1 },
          { "id": "get.exponent-1-tekort", "label": "Eén nul te weinig (10²)", "optionIndex": 2 },
          { "id": "get.exponent-1-teveel", "label": "Eén nul te veel (10⁴)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Bij grondtal 10 is de exponent het aantal nullen. $10^3$ = 10 × 10 × 10 = 1.000. Exponent 3 → 3 nullen → 1.000. Dus 1 kilobyte = 1.000 bytes. Deze regel werkt alleen bij grondtal 10 — daarom zijn machten van 10 zo handig bij het meetstelsel.",
        "solutionSteps": [
          "$10^3$ = 10 × 10 × 10",
          "10 × 10 = 100",
          "100 × 10 = 1.000",
          "Exponent 3 → 3 nullen → 1.000"
        ],
        "distractorExplanations": {
          "0": "Goed! $10^3$ = 1.000. Bij grondtal 10: exponent = aantal nullen achter de 1.",
          "1": "Je dacht waarschijnlijk dat je grondtal × exponent rekent. Maar 10 × 3 = 30 is vermenigvuldigen, niet machtsverheffen. Onthoud: $10^3$ = 10 × 10 × 10 = 1.000.",
          "2": "Je dacht waarschijnlijk dat het $10^2$ is. Maar $10^2$ = 100, terwijl $10^3$ = 1.000. Onthoud: exponent 3 betekent 3 nullen, dus drie keer een 0 achter de 1.",
          "3": "Je dacht waarschijnlijk dat het $10^4$ is. Maar $10^4$ = 10.000, terwijl $10^3$ = 1.000. Onthoud: tel het aantal nullen — dat is de exponent, hier 3."
        }
      }
    },
    {
      "id": "GET-MACHT-GRONDTAL-003",
      "familyId": "GET-MACHT-GRONDTAL",
      "module": "Getalbegrip",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_grondtal",
      "questionType": "multiple_choice",
      "question": "Een wiskundedocent vraagt: wat is $(-3)^2$?",
      "options": ["9", "−9", "−6", "6"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "squareGrid",
          "data": {
            "rows": 3,
            "cols": 3,
            "highlighted": "all",
            "label": "(−3)² als oppervlakte van een 3×3 vierkant = 9 vakjes. Min × min = plus."
          },
          "a11y": { "alt": "Vierkant raster van 3 bij 3 vakjes, alle 9 vakjes gemarkeerd" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Negatief grondtal met even exponent",
            "content": "Een negatief getal tot een even macht geeft een positief resultaat. Min × min = plus. Voorbeeld: $(-3)^2$ = $(-3)$ × $(-3)$ = +9.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "macht_negatief_grondtal_even",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.negatief-blijft-negatief", "label": "Denkt dat minteken blijft staan bij kwadraat", "optionIndex": 1 },
          { "id": "get.macht-als-vermenigvuldigen", "label": "Doet grondtal × exponent (−3 × 2)", "optionIndex": 2 },
          { "id": "get.macht-als-vermenigvuldigen", "label": "Doet grondtal × exponent (3 × 2)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Een negatief getal tot een even macht is altijd positief. $(-3)^2$ = $(-3)$ × $(-3)$. Volg de tekenregel: min × min = plus. Dan: 3 × 3 = 9, dus het antwoord is +9. Het minteken verdwijnt omdat je twee negatieve factoren met elkaar vermenigvuldigt — en die opheffen elkaar.",
        "solutionSteps": [
          "$(-3)^2$ = $(-3)$ × $(-3)$",
          "Min × min = plus",
          "3 × 3 = 9",
          "Antwoord: +9"
        ],
        "distractorExplanations": {
          "0": "Goed! $(-3)^2$ = $(-3)$ × $(-3)$ = +9. Even exponent → positief resultaat, omdat twee mintekens elkaar opheffen.",
          "1": "Je dacht waarschijnlijk dat het minteken blijft. Maar $(-3)^2$ = +9, niet −9. Onthoud: min × min = plus. Even exponent → altijd positief resultaat.",
          "2": "Je dacht waarschijnlijk dat je grondtal × exponent rekent. Maar −3 × 2 = −6 is vermenigvuldigen, niet machtsverheffen. Onthoud: $(-3)^2$ = $(-3)$ × $(-3)$ = +9, niet −3 × 2.",
          "3": "Je dacht waarschijnlijk dat 3 × 2 = 6, maar machtsverheffen is geen vermenigvuldiging met de exponent. Onthoud: $(-3)^2$ = $(-3)$ × $(-3)$ = +9."
        }
      }
    },
    {
      "id": "GET-MACHT-GRONDTAL-004",
      "familyId": "GET-MACHT-GRONDTAL",
      "module": "Getalbegrip",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_grondtal",
      "questionType": "multiple_choice",
      "question": "Een natuurkundige berekent $(-2)^3$. Wat is het antwoord?",
      "options": ["−8", "8", "−6", "6"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Negatief grondtal met oneven exponent",
            "content": "Een negatief getal tot een oneven macht geeft een negatief resultaat. Voorbeeld: $(-2)^3$ = $(-2)$ × $(-2)$ × $(-2)$ = −8.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "macht_negatief_grondtal_oneven",
      "variantIndex": 4,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.negatief-altijd-positief-bij-macht", "label": "Denkt dat macht altijd positief is", "optionIndex": 1 },
          { "id": "get.macht-als-vermenigvuldigen", "label": "Doet grondtal × exponent (−2 × 3)", "optionIndex": 2 },
          { "id": "get.macht-als-vermenigvuldigen", "label": "Doet grondtal × exponent (2 × 3)", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Een negatief getal tot een oneven macht is altijd negatief. $(-2)^3$ = $(-2)$ × $(-2)$ × $(-2)$. Reken stap voor stap met de tekenregels: $(-2)$ × $(-2)$ = +4 (min × min = plus). Dan +4 × $(-2)$ = −8 (plus × min = min). Bij een oneven aantal mintekens blijft het minteken staan.",
        "solutionSteps": [
          "$(-2)^3$ = $(-2)$ × $(-2)$ × $(-2)$",
          "$(-2)$ × $(-2)$ = +4",
          "+4 × $(-2)$ = −8",
          "Oneven exponent → negatief resultaat"
        ],
        "distractorExplanations": {
          "0": "Goed! $(-2)^3$ = −8. Oneven exponent → negatief resultaat, omdat één van de drie mintekens niet wordt opgeheven.",
          "1": "Je dacht waarschijnlijk dat het minteken altijd verdwijnt. Maar $(-2)^3$ = −8, niet +8. Onthoud: oneven exponent → negatief resultaat, even exponent → positief.",
          "2": "Je dacht waarschijnlijk dat je grondtal × exponent rekent. Maar −2 × 3 = −6 is vermenigvuldigen, niet machtsverheffen. Onthoud: $(-2)^3$ = $(-2)$ × $(-2)$ × $(-2)$ = −8.",
          "3": "Je dacht waarschijnlijk dat 2 × 3 = 6, maar machtsverheffen is geen vermenigvuldiging met de exponent. Onthoud: $(-2)^3$ = −8 (oneven exponent → negatief)."
        }
      }
    },
    {
      "id": "GET-MACHT-GRONDTAL-005",
      "familyId": "GET-MACHT-GRONDTAL",
      "module": "Getalbegrip",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_grondtal",
      "questionType": "fill_in",
      "question": "Bereken: $4^3$ = ? Typ alleen het getal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["64"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stap voor stap",
            "content": "$4^3$ = 4 × 4 × 4. Reken: 4 × 4 = 16, dan 16 × 4 = 64.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "macht_grondtal_4_compute",
      "variantIndex": 5,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "$4^3$ = 4 × 4 × 4 = 64. Reken in stappen: 4 × 4 = 16, dan 16 × 4 = 64. Onthoud: het grondtal (4) staat onder, de exponent (3) zegt hoe vaak je vermenigvuldigt.",
        "solutionSteps": [
          "$4^3$ = 4 × 4 × 4",
          "4 × 4 = 16",
          "16 × 4 = 64",
          "Antwoord: 64"
        ]
      }
    },
    {
      "id": "GET-MACHT-GRONDTAL-006",
      "familyId": "GET-MACHT-GRONDTAL",
      "module": "Getalbegrip",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "machten_wortels",
      "subSkill": "macht_grondtal",
      "questionType": "comparison_judge",
      "question": "Twee leerlingen rekenen $(-4)^2$ uit. Wie redeneert correct?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "lisa", "content": "Lisa: $(-4)^2$ = $(-4)$ × $(-4)$ = +16 (twee mintekens heffen elkaar op, even exponent → positief)" },
            { "id": "tom", "content": "Tom: $(-4)^2$ = −16 (het minteken hoort bij het grondtal en blijft staan)" },
            { "id": "sam", "content": "Sam: $(-4)^2$ = −4 × 2 = −8 (grondtal keer exponent)" }
          ],
          "criterion": "Wie past de tekenregels correct toe bij machtsverheffen?",
          "correctIndex": 0
        }
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Even exponent + negatief grondtal",
            "content": "$(-a)^n$ met n even → positief, want elk paar mintekens heft elkaar op. Bij $(-4)^2$: $(-4)$ × $(-4)$ = +16.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "macht_grondtal_redeneer_teken",
      "variantIndex": 6,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "get.negatief-blijft-negatief", "label": "Denkt dat minteken altijd blijft staan", "optionIndex": 1 },
          { "id": "get.macht-als-vermenigvuldigen", "label": "Doet grondtal × exponent", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "Lisa redeneert correct. Bij $(-4)^2$ vermenigvuldig je $(-4)$ met zichzelf: $(-4)$ × $(-4)$. Min × min = plus, dus het minteken verdwijnt. Resultaat: +16. Tom maakt de fout dat hij het minteken laat staan, maar bij een even exponent heffen de mintekens elkaar op. Sam doet grondtal × exponent — dat is geen machtsverheffen.",
        "solutionSteps": [
          "$(-4)^2$ = $(-4)$ × $(-4)$",
          "Min × min = plus",
          "4 × 4 = 16",
          "Even exponent → positief: $(-4)^2$ = +16"
        ]
      }
    }
  ]
}
